'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/** Icon wrapper for the icon font*/
var Icon = function Icon(_ref) {
  var type = _ref.type,
    large = _ref.large,
    muted = _ref.muted,
    noLineHeight = _ref.noLineHeight;
  var iconClassNames = (0, _classnames2.default)('if', 'if-' + type, {
    'if--line': !noLineHeight
  }, {
    'if--large': large
  }, {
    'u-text-muted': muted
  });
  return _react2.default.createElement('i', {
    className: iconClassNames
  });
};
Icon.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Type of the icon*/
  type: _propTypes2.default.oneOf(['add', 'add-patient', 'add-to-folder', 'added-to-folder', 'alert', 'arrow-down', 'arrow-left', 'arrow-right', 'arrow-up', 'attachment', 'calendar', 'camera', 'caret-down', 'caret-left', 'caret-right', 'caret-up', 'checkmark', 'chevron-down', 'chevron-left', 'chevron-right', 'chevron-up', 'clock', 'close', 'consultation', 'delete', 'document', 'download', 'duplicate', 'edit', 'expand-area', 'file', 'help', 'inbox', 'info', 'log-out', 'message', 'notifications', 'options', 'patients', 'prescription', 'prescription-link-failed', 'prescription-linked', 'prescription-unused', 'print', 'remove', 'search', 'settings', 'success-circle']).isRequired,
  /** Whether to render a large icon or not */
  large: _propTypes2.default.bool,
  /** Whether to render a muted icon or not */
  muted: _propTypes2.default.bool,
  /** Whether to render an icon with a line height or not */
  noLineHeight: _propTypes2.default.bool
} : {};
exports.default = Icon;